// extracted by mini-css-extract-plugin
export default {"title":"OrdersNoResultScreen_title__CHw0h","body":"OrdersNoResultScreen_body__HAgqA"};